// extracted by mini-css-extract-plugin
module.exports = {"detailsDivider":"FlagDetailsContainer-detailsDivider-50d701a5a0e1e490513adf86dc329d49"};